var FeaturesDisplay = (function(window, $){
    var cached = {};

    return {
        init: function init() {
            cached.element = $('.c-features-display');
            cached.items = cached.element.find('.c-features-display__item');
            cached.itemLength = cached.items.length - 1;
            cached.currentIndex = 0;
            cached.timer;

            this.display(0);
            this.autoStart();
        },

        autoStart: function autoStart() {
            var that = this;

            clearTimeout(cached.timer);

            cached.timer = setTimeout(function () {
                var nextIndex = cached.currentIndex + 1
                var newIndex = nextIndex > cached.itemLength ? 0 : nextIndex;

                that.display( newIndex );
            }, 5000);
        },

        display: function display(index) {
            cached.items
                .removeClass('is-active')
                .eq(index)
                .addClass('is-active');

            cached.currentIndex = index;

            this.autoStart();
        }
    }
})(window, jQuery);

FeaturesDisplay.init();
